import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getStaffList } from '@/service/dashboard';

// ==================== 数据处理函数 ====================

// 只处理 default，直接返回后端数据
const processSingleDataType = ({ data, dataType = 'default' }) => {
    switch (dataType) {
        default: {
          console.log('processSingleDataType', data);
          return data
        }
    }
  if (dataType === 'default') return Array.isArray(data) ? data : [];
  return Array.isArray(data) ? data : [];
};

// ==================== 异步Action ====================

export const fetchStaffList = createAsyncThunk(
  'staff/fetchStaffList',
  async ({ query = {}, dataType = 'default' } = {}, { rejectWithValue }) => {
    try {
      const response = await getStaffList(query);
      return { data: response.data, query, dataType };
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取员工列表失败');
    }
  }
);

// ==================== Redux Slice ====================

const staffSlice = createSlice({
  name: 'staff',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: []
  },
  reducers: {
    resetStaffState: (state) => {
      state.fetching = false;
      state.error = null;
      state.query = {};
      state.data = [];
    },
    setQuery: (state, action) => {
      state.query = { ...state.query, ...(action.payload || {}) };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStaffList.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = (action.meta?.arg && action.meta.arg.query) || {};
        state.data = [];
      })
      .addCase(fetchStaffList.fulfilled, (state, action) => {
        const { data, dataType, query } = action.payload || {};
        state.fetching = false;
        state.error = null;
        state.query = query || {};
        state.data = processSingleDataType({ data, dataType });
      })
      .addCase(fetchStaffList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = [];
      });
  }
});

export const { resetStaffState, setQuery } = staffSlice.actions;

export default staffSlice.reducer;


